import './App.css';
import { BrowserRouter, Routes, Route  } from 'react-router-dom';


import PageHome from './components/pages/home';
import PageNotFound from './components/pages/NotFound';
import PageContact from './components/pages/contact';
import PageProjects from './components/pages/projects';
import PageMedia from './components/pages/media';
import PageTerms from './components/pages/terms';
import PagePrivacy from './components/pages/privacy';
import PageServices from './components/pages/services';
import PageAudience from './components/pages/audience';
import PageCalendar from './components/pages/calendar';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageHome />} />
          <Route path="/home" element={<PageHome />} />
          <Route path="/audience" element={<PageAudience />} />
          { false && <Route path="/calendar" element={<PageCalendar />} /> }
          <Route path="/contact" element={<PageContact />} />
          <Route path="/media" element={<PageMedia />} />
          <Route path="/privacy" element={<PagePrivacy />} />
          <Route path="/projects" element={<PageProjects />} />
          <Route path="/services" element={<PageServices />} />
          <Route path="/terms" element={<PageTerms />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
